unit View.Clientes.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UConstantes, UUtils, UHelperServer, System.StrUtils,
  UPersonalizacao_Tabela, UPersonalizacao_Tabela.Interfaces,
  UFrameFinanceiroCliente, Vcl.Forms, XData.Web.Client;

type
  TFViewClientesList = class(TForm)
    ClientesDataset: TXDataWebDataSet;
    ClientesDatasetid: TIntegerField;
    ClientesDatasetrazao_social_nome: TStringField;
    ClientesDatasetnome_fantasia_apelido: TStringField;
    ClientesDatasetcpf_cnpj: TStringField;
    ClientesDatasetcadastro: TDateTimeField;
    ClientesDatasetstatus: TIntegerField;
    ClientesDatasetemail: TStringField;
    ClientesDatasetendereco: TStringField;
    ClientesDatasetnumero: TStringField;
    ClientesDatasetbairro: TStringField;
    ClientesDatasetcep: TStringField;
    ClientesDatasettelefones: TStringField;
    ClientesDatasetcodigo_interno: TIntegerField;
    ClientesDatasetexcluido: TBooleanField;
    ClientesDatasetinclusao: TDateTimeField;
    ClientesDatasetalteracao: TDateTimeField;
    ClientesDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    tmrConsulta: TTimer;
    btnExportarExcel: TButton;
    cbbClienteStatus: TComboBox;
    cbxClientesExcluidos: TCheckBox;
    edtCidadeNome: TEdit;
    btnPesquisarCidade: TButton;
    ClientesDatasetcidadeNome: TStringField;
    ClientesDatasetcidadeufSigla: TStringField;
    frmFinanceiro: TfrmFinanceiroCliente;
    lbModalTitulo: TLabel;
    ClientesDatasetis_pj: TBooleanField;
    ClientesDatasetcomplemento: TStringField;
    procedure WebFormCreate(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure tmrConsultaTimer(Sender: TObject);
    [async]
    procedure btnPesquisarCidadeClick(Sender: TObject); async;
    procedure WebDBTableControl1GetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
    procedure ClientesDatasetcpf_cnpjGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure ClientesDatasetcepGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure ClientesDatasettelefonesGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure WebDBTableControl1GetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure ClientesDatasetcidadeNomeGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure ClientesDatasetemailGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure cbbClienteStatusChange(Sender: TObject);
    procedure cbxClientesExcluidosClick(Sender: TObject);
    procedure ClientesDatasetenderecoGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure btnExportarExcelClick(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
    FPersonalizacaoTabela: IPersonalizacao_Tabela;
    FClienteSelecionado : string;

    function GetFiltro : string;
    procedure Filtrar;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewClientesList: TFViewClientesList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewClientesList }

procedure TFViewClientesList.btnExportarExcelClick(Sender: TObject);
begin
  TUtils.ExportarDadosExcel(ClientesDataset, WebDBTableControl1,
    FGridPlugin.FDatasetPlugin.FDataset.QueryString, FGridPlugin.FQuantidadeRegistrosBusca);
end;

procedure TFViewClientesList.btnPesquisarCidadeClick(Sender: TObject);
var
  lBackupTag : Integer;
begin
  lBackupTag := edtCidadeNome.Tag;
  Await(THelperServer.ChamarConsulta('Cidades', 'Cidade', edtCidadeNome));

  if lBackupTag <> edtCidadeNome.Tag then
    Filtrar;
end;

procedure TFViewClientesList.cbbClienteStatusChange(Sender: TObject);
begin
  Filtrar;
end;

procedure TFViewClientesList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

procedure TFViewClientesList.cbxClientesExcluidosClick(Sender: TObject);
begin
  Filtrar;
end;

procedure TFViewClientesList.ClientesDatasetcepGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatarCEP(Sender.AsString);
end;

procedure TFViewClientesList.ClientesDatasetcidadeNomeGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatarCidadeEstado(Sender.AsString, ClientesDataset.FieldByName('cidade.uf.Sigla').AsString);
end;

procedure TFViewClientesList.ClientesDatasetcpf_cnpjGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatarCnpj_Cpf(Sender.AsString);
end;

procedure TFViewClientesList.ClientesDatasetemailGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := UpperCase(Sender.AsString);
end;

procedure TFViewClientesList.ClientesDatasetenderecoGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := THelperServer.FormatarEndereco(Sender.AsString, ClientesDataset.FieldByName('numero').AsString,
    ClientesDataset.FieldByName('bairro').AsString, EmptyStr);
end;

procedure TFViewClientesList.ClientesDatasettelefonesGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := THelperServer.GetTelefoneUnicoJson(Sender.AsString);
end;

class function TFViewClientesList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewClientesList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewClientesList, AElementID, Result, @AfterCreate);
end;

procedure TFViewClientesList.edSearchKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
    FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewClientesList.edSearchKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

procedure TFViewClientesList.Filtrar;
begin
  FGridPlugin.FDatasetPlugin.FFilterPadrao := Trim(GetFiltro);
  FGridPlugin.Load;
end;

function TFViewClientesList.GetFiltro: string;
begin
  case cbbClienteStatus.ItemIndex of
    0 : Result := '(status ne 2)';
    3 : Result := '(status eq 4)';
    4 : Result := '(status eq 5)';
    5 : Result := EmptyStr
    else Result := '(status eq ' + cbbClienteStatus.ItemIndex.ToString + ')';
  end;

  if not cbxClientesExcluidos.Checked then
  begin
    if Trim(Result) = '' then
      Result := '(excluido eq false)'
    else
      Result := Result + ' and (excluido eq false)';
  end;

  if edtCidadeNome.Tag <> 0 then
  begin
    if Trim(Result) = '' then
      Result := '(cidade_id eq '+edtCidadeNome.Tag.ToString+')'
    else
      Result := Result + ' and (cidade_id eq '+edtCidadeNome.Tag.ToString+')';
  end;
end;

procedure TFViewClientesList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

procedure TFViewClientesList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;
  RecordClientId,
  RecordNome : string;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

  procedure FinanceiroButtonClick(Sender: TObject);
  begin
    if FClienteSelecionado <> RecordClientId then
    begin
      FClienteSelecionado := RecordClientId;
      TUtils.SelecionarTab('#line-debitos-tab');
      lbModalTitulo.Caption := RecordNome;
      frmFinanceiro.cdsDebitos.Tag := 0;
      frmFinanceiro.cdsRecebimentos.Tag := 0;
      frmFinanceiro.CarregarInformacoesIniciais(RecordClientId);
    end;

    TUtils.OpenModal('modal_financeiro_cliente');
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Ações' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      ClientesDataset.Connection.Model.DefaultSchema.FindEntityType(ClientesDataset.EntitySetName),
      ClientesDataset.CurrentData
    );

    RecordClientId := ClientesDataset.FieldByName('id').AsString;

    if ClientesDataset.FieldByName('is_pj').AsBoolean then
      RecordNome := ClientesDataset.FieldByName('nome_fantasia_apelido').AsString
    else
      RecordNome := ClientesDataset.FieldByName('razao_social_nome').AsString;

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fas fa-eye"></i>';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-test', 'btn_visualizar_cliente');

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fas fa-money-check-alt"></i>';
    Button.OnClick := @FinanceiroButtonClick;
    Button.ElementClassName := 'btn btn-link btn-secondary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
    Button.ElementHandle.setAttribute('title', 'Ver financeiro cliente');
    Button.ElementHandle.setAttribute('data-test', 'btn_financeiro_cliente');
  end;
end;

procedure TFViewClientesList.WebDBTableControl1GetCellClass(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['cpf_cnpj', 'telefones',
      'email', 'endereco', 'cidade.Nome', 'razao_social_nome', 'nome_fantasia_apelido']) of
      0, 1, 2, 3, 4, 5, 6: AClassName := 'text-start';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewClientesList.WebDBTableControl1GetCellData(Sender: TObject;
  ACol, ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow = 0 then
    Exit;

  case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['status', 'excluido']) of
    0:
    begin
      case StrToInt(AValue) of
        1 : AValue := '<div class="rounded-pill text-center" style="background-color: #198754;color:white; padding-right: 5px;padding-left: 5px;">Ativo</div>';
        2 : AValue := '<div class="rounded-pill text-center" style="background-color: #FF6347;color:white; padding-right: 5px;padding-left: 5px;">Inativo</div>';
        5 : AValue := '<div class="rounded-pill text-center" style="background-color: #0054C3;color:white; padding-right: 5px;padding-left: 5px;">Serviço de Proteção</div>';
        4 : AValue := '<div class="rounded-pill text-center" style="background-color: #ffad46;color:white; padding-right: 5px;padding-left: 5px;">Bloqueado</div>';
        else AValue := '<div class="rounded-pill text-center" style="background-color: #1C1C1C;color:white; padding-right: 5px;padding-left: 5px;">Outros</div>';
      end;
    end;
    1:
    begin
      if AValue = 'True' then
        AValue := '<i class="fas fa-check text-success"><i>'
      else if AValue = 'False' then
        AValue := '<i class="fas fa-times text-danger"><i>';
    end;
  end;
end;

procedure TFViewClientesList.WebFormCreate(Sender: TObject);
begin
  FClienteSelecionado := EmptyStr;
  FPersonalizacaoTabela := TPersonalizacao_Tabela.Create(Self.Name, WebDBTableControl1,
    cbPageSize);

  TUtils.SetValorDicionarioClasses('clientes', 'active');
  TUtils.SetValorDicionarioClasses('cadastros_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_cadastros', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(WebDBTableControl1, ClientesDataset, lcPaginator,
    lbPaginationInfo);

  FGridPlugin.FDatasetPlugin.FOrderByPadrao := 'razao_social_nome, nome_fantasia_apelido';
  FGridPlugin.FDatasetPlugin.FFilterPadrao := Trim(GetFiltro);
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewClientesList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.clientes.list.pagination.info');
  lbModalTitulo := TLabel.Create('modal_financeiro_cliente_Label');
  WebDBTableControl1 := TDBTableControl.Create('view.clientes.list.table');
  cbPageSize := TComboBox.Create('view.clientes.list.cbPageSize');
  edSearch := TEdit.Create('view.clientes.list.search');
  lcPaginator := TListControl.Create('view.clientes.list.pagination');
  btnExportarExcel := TButton.Create('btnExportarExcel');
  cbbClienteStatus := TComboBox.Create('cbbClienteStatus');
  cbxClientesExcluidos := TCheckBox.Create('cbxClientesExcluidos');
  edtCidadeNome := TEdit.Create('edtCidadeNome');
  btnPesquisarCidade := TButton.Create('btnPesquisarCidade');
  frmFinanceiro := TfrmFinanceiroCliente.Create(Self);
  ClientesDataset := TXDataWebDataSet.Create(Self);
  ClientesDatasetid := TIntegerField.Create(Self);
  ClientesDatasetcodigo_interno := TIntegerField.Create(Self);
  ClientesDatasetrazao_social_nome := TStringField.Create(Self);
  ClientesDatasetnome_fantasia_apelido := TStringField.Create(Self);
  ClientesDatasetcpf_cnpj := TStringField.Create(Self);
  ClientesDatasetstatus := TIntegerField.Create(Self);
  ClientesDatasettelefones := TStringField.Create(Self);
  ClientesDatasetemail := TStringField.Create(Self);
  ClientesDatasetcidadeNome := TStringField.Create(Self);
  ClientesDatasetcidadeufSigla := TStringField.Create(Self);
  ClientesDatasetcep := TStringField.Create(Self);
  ClientesDatasetendereco := TStringField.Create(Self);
  ClientesDatasetnumero := TStringField.Create(Self);
  ClientesDatasetbairro := TStringField.Create(Self);
  ClientesDatasetcomplemento := TStringField.Create(Self);
  ClientesDatasetcadastro := TDateTimeField.Create(Self);
  ClientesDatasetis_pj := TBooleanField.Create(Self);
  ClientesDatasetexcluido := TBooleanField.Create(Self);
  ClientesDatasetinclusao := TDateTimeField.Create(Self);
  ClientesDatasetalteracao := TDateTimeField.Create(Self);
  ClientesDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);

  frmFinanceiro.LoadFromForm;
  lbPaginationInfo.BeforeLoadDFMValues;
  lbModalTitulo.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  btnExportarExcel.BeforeLoadDFMValues;
  cbbClienteStatus.BeforeLoadDFMValues;
  cbxClientesExcluidos.BeforeLoadDFMValues;
  edtCidadeNome.BeforeLoadDFMValues;
  btnPesquisarCidade.BeforeLoadDFMValues;
  frmFinanceiro.BeforeLoadDFMValues;
  frmFinanceiro.lbPaginationInfoDebitos.BeforeLoadDFMValues;
  frmFinanceiro.lblDebitosAVencer.BeforeLoadDFMValues;
  frmFinanceiro.lblDebitosVencidos.BeforeLoadDFMValues;
  frmFinanceiro.lblTotalDebitos.BeforeLoadDFMValues;
  frmFinanceiro.lblUltimaCompra.BeforeLoadDFMValues;
  frmFinanceiro.lblTotalCompras.BeforeLoadDFMValues;
  frmFinanceiro.lblQuantidadeCompras.BeforeLoadDFMValues;
  ClientesDataset.BeforeLoadDFMValues;
  ClientesDatasetid.BeforeLoadDFMValues;
  ClientesDatasetcodigo_interno.BeforeLoadDFMValues;
  ClientesDatasetrazao_social_nome.BeforeLoadDFMValues;
  ClientesDatasetnome_fantasia_apelido.BeforeLoadDFMValues;
  ClientesDatasetcpf_cnpj.BeforeLoadDFMValues;
  ClientesDatasetstatus.BeforeLoadDFMValues;
  ClientesDatasettelefones.BeforeLoadDFMValues;
  ClientesDatasetemail.BeforeLoadDFMValues;
  ClientesDatasetcidadeNome.BeforeLoadDFMValues;
  ClientesDatasetcidadeufSigla.BeforeLoadDFMValues;
  ClientesDatasetcep.BeforeLoadDFMValues;
  ClientesDatasetendereco.BeforeLoadDFMValues;
  ClientesDatasetnumero.BeforeLoadDFMValues;
  ClientesDatasetbairro.BeforeLoadDFMValues;
  ClientesDatasetcomplemento.BeforeLoadDFMValues;
  ClientesDatasetcadastro.BeforeLoadDFMValues;
  ClientesDatasetis_pj.BeforeLoadDFMValues;
  ClientesDatasetexcluido.BeforeLoadDFMValues;
  ClientesDatasetinclusao.BeforeLoadDFMValues;
  ClientesDatasetalteracao.BeforeLoadDFMValues;
  ClientesDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  try
    Name := 'FViewClientesList';
    Width := 621;
    Height := 404;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 128;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    lbModalTitulo.SetParentComponent(Self);
    lbModalTitulo.Name := 'lbModalTitulo';
    lbModalTitulo.Left := 384;
    lbModalTitulo.Top := 115;
    lbModalTitulo.Width := 62;
    lbModalTitulo.Height := 13;
    lbModalTitulo.Caption := 'lbModalTitulo';
    lbModalTitulo.HeightPercent := 100.000000000000000000;
    lbModalTitulo.WidthPercent := 100.000000000000000000;
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 30;
    WebDBTableControl1.Width := 321;
    WebDBTableControl1.Height := 79;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.WidthPercent := 130.000000000000000000;
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellData', 'WebDBTableControl1GetCellData');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellClass', 'WebDBTableControl1GetCellClass');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'A'#231#245'es';
      Width := 100;
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'C'#243'd. Retaguarda';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'razao_social_nome';
      Title := 'Nome/Raz'#227'o Social';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome_fantasia_apelido';
      Title := 'Apelido/Nome Fantasia';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cpf_cnpj';
      Title := 'Documento';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'status';
      Title := 'status';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'telefones';
      Title := 'telefone';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'email';
      Title := 'email';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cidade.Nome';
      Title := 'Cidade';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cep';
      Title := 'cep';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'endereco';
      Title := 'endereco';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cadastro';
      Title := 'cadastro';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 3;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 208;
    edSearch.Top := 3;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 115;
    lcPaginator.Width := 89;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    btnExportarExcel.SetParentComponent(Self);
    btnExportarExcel.Name := 'btnExportarExcel';
    btnExportarExcel.Left := 384;
    btnExportarExcel.Top := 1;
    btnExportarExcel.Width := 96;
    btnExportarExcel.Height := 25;
    btnExportarExcel.Caption := 'Exportar Excel';
    btnExportarExcel.ChildOrder := 11;
    btnExportarExcel.HeightPercent := 100.000000000000000000;
    btnExportarExcel.WidthPercent := 100.000000000000000000;
    SetEvent(btnExportarExcel, Self, 'OnClick', 'btnExportarExcelClick');
    cbbClienteStatus.SetParentComponent(Self);
    cbbClienteStatus.Name := 'cbbClienteStatus';
    cbbClienteStatus.Left := 384;
    cbbClienteStatus.Top := 32;
    cbbClienteStatus.Width := 96;
    cbbClienteStatus.Height := 21;
    cbbClienteStatus.HeightPercent := 100.000000000000000000;
    cbbClienteStatus.Text := '<> Inativo';
    cbbClienteStatus.WidthPercent := 100.000000000000000000;
    SetEvent(cbbClienteStatus, Self, 'OnChange', 'cbbClienteStatusChange');
    cbbClienteStatus.ItemIndex := 0;
    cbbClienteStatus.Items.BeginUpdate;
    try
      cbbClienteStatus.Items.Clear;
      cbbClienteStatus.Items.Add('<> Inativo');
      cbbClienteStatus.Items.Add('Ativo');
      cbbClienteStatus.Items.Add('Inativo');
      cbbClienteStatus.Items.Add('Bloqueado');
      cbbClienteStatus.Items.Add('Servi'#231'o de prote'#231#227'o');
      cbbClienteStatus.Items.Add('Todos');
    finally
      cbbClienteStatus.Items.EndUpdate;
    end;
    cbxClientesExcluidos.SetParentComponent(Self);
    cbxClientesExcluidos.Name := 'cbxClientesExcluidos';
    cbxClientesExcluidos.Left := 384;
    cbxClientesExcluidos.Top := 59;
    cbxClientesExcluidos.Width := 145;
    cbxClientesExcluidos.Height := 22;
    cbxClientesExcluidos.Caption := 'Exibir Exclu'#237'dos?';
    cbxClientesExcluidos.ChildOrder := 9;
    cbxClientesExcluidos.HeightPercent := 100.000000000000000000;
    cbxClientesExcluidos.WidthPercent := 100.000000000000000000;
    SetEvent(cbxClientesExcluidos, Self, 'OnClick', 'cbxClientesExcluidosClick');
    edtCidadeNome.SetParentComponent(Self);
    edtCidadeNome.Name := 'edtCidadeNome';
    edtCidadeNome.Left := 384;
    edtCidadeNome.Top := 87;
    edtCidadeNome.Width := 120;
    edtCidadeNome.Height := 22;
    edtCidadeNome.ChildOrder := 21;
    edtCidadeNome.Enabled := False;
    edtCidadeNome.HeightPercent := 100.000000000000000000;
    edtCidadeNome.WidthPercent := 100.000000000000000000;
    btnPesquisarCidade.SetParentComponent(Self);
    btnPesquisarCidade.Name := 'btnPesquisarCidade';
    btnPesquisarCidade.Left := 505;
    btnPesquisarCidade.Top := 87;
    btnPesquisarCidade.Width := 30;
    btnPesquisarCidade.Height := 22;
    btnPesquisarCidade.ChildOrder := 22;
    btnPesquisarCidade.HeightPercent := 100.000000000000000000;
    btnPesquisarCidade.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisarCidade, Self, 'OnClick', 'btnPesquisarCidadeClick');
    frmFinanceiro.SetParentComponent(Self);
    frmFinanceiro.Name := 'frmFinanceiro';
    frmFinanceiro.Left := 8;
    frmFinanceiro.Top := 152;
    frmFinanceiro.Width := 564;
    frmFinanceiro.Height := 241;
    frmFinanceiro.TabOrder := 9;
    frmFinanceiro.Visible := False;
    frmFinanceiro.lbPaginationInfoDebitos.Width := 141;
    frmFinanceiro.lbPaginationInfoDebitos.Height := 13;
    frmFinanceiro.lblDebitosAVencer.Width := 4;
    frmFinanceiro.lblDebitosAVencer.Height := 13;
    frmFinanceiro.lblDebitosVencidos.Width := 4;
    frmFinanceiro.lblDebitosVencidos.Height := 13;
    frmFinanceiro.lblTotalDebitos.Width := 4;
    frmFinanceiro.lblTotalDebitos.Height := 13;
    frmFinanceiro.lblUltimaCompra.Width := 4;
    frmFinanceiro.lblUltimaCompra.Height := 13;
    frmFinanceiro.lblTotalCompras.Width := 4;
    frmFinanceiro.lblTotalCompras.Height := 13;
    frmFinanceiro.lblQuantidadeCompras.Width := 4;
    frmFinanceiro.lblQuantidadeCompras.Height := 13;
    ClientesDataset.SetParentComponent(Self);
    ClientesDataset.Name := 'ClientesDataset';
    ClientesDataset.EntitySetName := 'Clientes';
    ClientesDataset.Connection := DMConnection.ApiConnection;
    ClientesDataset.Left := 40;
    ClientesDataset.Top := 48;
    ClientesDatasetid.SetParentComponent(ClientesDataset);
    ClientesDatasetid.Name := 'ClientesDatasetid';
    ClientesDatasetid.Tag := 1;
    ClientesDatasetid.FieldName := 'id';
    ClientesDatasetid.Required := True;
    ClientesDatasetcodigo_interno.SetParentComponent(ClientesDataset);
    ClientesDatasetcodigo_interno.Name := 'ClientesDatasetcodigo_interno';
    ClientesDatasetcodigo_interno.FieldName := 'codigo_interno';
    ClientesDatasetcodigo_interno.Required := True;
    ClientesDatasetrazao_social_nome.SetParentComponent(ClientesDataset);
    ClientesDatasetrazao_social_nome.Name := 'ClientesDatasetrazao_social_nome';
    ClientesDatasetrazao_social_nome.FieldName := 'razao_social_nome';
    ClientesDatasetrazao_social_nome.Required := True;
    ClientesDatasetrazao_social_nome.Size := 255;
    ClientesDatasetnome_fantasia_apelido.SetParentComponent(ClientesDataset);
    ClientesDatasetnome_fantasia_apelido.Name := 'ClientesDatasetnome_fantasia_apelido';
    ClientesDatasetnome_fantasia_apelido.FieldName := 'nome_fantasia_apelido';
    ClientesDatasetnome_fantasia_apelido.Size := 255;
    ClientesDatasetcpf_cnpj.SetParentComponent(ClientesDataset);
    ClientesDatasetcpf_cnpj.Name := 'ClientesDatasetcpf_cnpj';
    ClientesDatasetcpf_cnpj.FieldName := 'cpf_cnpj';
    SetEvent(ClientesDatasetcpf_cnpj, Self, 'OnGetText', 'ClientesDatasetcpf_cnpjGetText');
    ClientesDatasetcpf_cnpj.Size := 255;
    ClientesDatasetstatus.SetParentComponent(ClientesDataset);
    ClientesDatasetstatus.Name := 'ClientesDatasetstatus';
    ClientesDatasetstatus.FieldName := 'status';
    ClientesDatasetstatus.Required := True;
    ClientesDatasettelefones.SetParentComponent(ClientesDataset);
    ClientesDatasettelefones.Name := 'ClientesDatasettelefones';
    ClientesDatasettelefones.FieldName := 'telefones';
    ClientesDatasettelefones.Required := True;
    SetEvent(ClientesDatasettelefones, Self, 'OnGetText', 'ClientesDatasettelefonesGetText');
    ClientesDatasettelefones.Size := 255;
    ClientesDatasetemail.SetParentComponent(ClientesDataset);
    ClientesDatasetemail.Name := 'ClientesDatasetemail';
    ClientesDatasetemail.FieldName := 'email';
    SetEvent(ClientesDatasetemail, Self, 'OnGetText', 'ClientesDatasetemailGetText');
    ClientesDatasetemail.Size := 255;
    ClientesDatasetcidadeNome.SetParentComponent(ClientesDataset);
    ClientesDatasetcidadeNome.Name := 'ClientesDatasetcidadeNome';
    ClientesDatasetcidadeNome.FieldName := 'cidade.Nome';
    SetEvent(ClientesDatasetcidadeNome, Self, 'OnGetText', 'ClientesDatasetcidadeNomeGetText');
    ClientesDatasetcidadeufSigla.SetParentComponent(ClientesDataset);
    ClientesDatasetcidadeufSigla.Name := 'ClientesDatasetcidadeufSigla';
    ClientesDatasetcidadeufSigla.Tag := 3;
    ClientesDatasetcidadeufSigla.FieldName := 'cidade.uf.Sigla';
    ClientesDatasetcep.SetParentComponent(ClientesDataset);
    ClientesDatasetcep.Name := 'ClientesDatasetcep';
    ClientesDatasetcep.FieldName := 'cep';
    ClientesDatasetcep.Required := True;
    SetEvent(ClientesDatasetcep, Self, 'OnGetText', 'ClientesDatasetcepGetText');
    ClientesDatasetcep.Size := 255;
    ClientesDatasetendereco.SetParentComponent(ClientesDataset);
    ClientesDatasetendereco.Name := 'ClientesDatasetendereco';
    ClientesDatasetendereco.FieldName := 'endereco';
    SetEvent(ClientesDatasetendereco, Self, 'OnGetText', 'ClientesDatasetenderecoGetText');
    ClientesDatasetendereco.Size := 255;
    ClientesDatasetnumero.SetParentComponent(ClientesDataset);
    ClientesDatasetnumero.Name := 'ClientesDatasetnumero';
    ClientesDatasetnumero.Tag := 3;
    ClientesDatasetnumero.FieldName := 'numero';
    ClientesDatasetnumero.Size := 255;
    ClientesDatasetbairro.SetParentComponent(ClientesDataset);
    ClientesDatasetbairro.Name := 'ClientesDatasetbairro';
    ClientesDatasetbairro.Tag := 3;
    ClientesDatasetbairro.FieldName := 'bairro';
    ClientesDatasetbairro.Size := 255;
    ClientesDatasetcomplemento.SetParentComponent(ClientesDataset);
    ClientesDatasetcomplemento.Name := 'ClientesDatasetcomplemento';
    ClientesDatasetcomplemento.Tag := 3;
    ClientesDatasetcomplemento.FieldName := 'complemento';
    ClientesDatasetcomplemento.Size := 255;
    ClientesDatasetcadastro.SetParentComponent(ClientesDataset);
    ClientesDatasetcadastro.Name := 'ClientesDatasetcadastro';
    ClientesDatasetcadastro.FieldName := 'cadastro';
    ClientesDatasetcadastro.DisplayFormat := 'dd/mm/yy';
    ClientesDatasetis_pj.SetParentComponent(ClientesDataset);
    ClientesDatasetis_pj.Name := 'ClientesDatasetis_pj';
    ClientesDatasetis_pj.FieldName := 'is_pj';
    ClientesDatasetexcluido.SetParentComponent(ClientesDataset);
    ClientesDatasetexcluido.Name := 'ClientesDatasetexcluido';
    ClientesDatasetexcluido.FieldName := 'excluido';
    ClientesDatasetinclusao.SetParentComponent(ClientesDataset);
    ClientesDatasetinclusao.Name := 'ClientesDatasetinclusao';
    ClientesDatasetinclusao.FieldName := 'inclusao';
    ClientesDatasetinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    ClientesDatasetalteracao.SetParentComponent(ClientesDataset);
    ClientesDatasetalteracao.Name := 'ClientesDatasetalteracao';
    ClientesDatasetalteracao.FieldName := 'alteracao';
    ClientesDatasetalteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    ClientesDatasetexclusao.SetParentComponent(ClientesDataset);
    ClientesDatasetexclusao.Name := 'ClientesDatasetexclusao';
    ClientesDatasetexclusao.FieldName := 'exclusao';
    ClientesDatasetexclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := ClientesDataset;
    WebDataSource.Left := 128;
    WebDataSource.Top := 48;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 216;
    tmrConsulta.Top := 40;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    lbModalTitulo.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    btnExportarExcel.AfterLoadDFMValues;
    cbbClienteStatus.AfterLoadDFMValues;
    cbxClientesExcluidos.AfterLoadDFMValues;
    edtCidadeNome.AfterLoadDFMValues;
    btnPesquisarCidade.AfterLoadDFMValues;
    frmFinanceiro.AfterLoadDFMValues;
    frmFinanceiro.lbPaginationInfoDebitos.AfterLoadDFMValues;
    frmFinanceiro.lblDebitosAVencer.AfterLoadDFMValues;
    frmFinanceiro.lblDebitosVencidos.AfterLoadDFMValues;
    frmFinanceiro.lblTotalDebitos.AfterLoadDFMValues;
    frmFinanceiro.lblUltimaCompra.AfterLoadDFMValues;
    frmFinanceiro.lblTotalCompras.AfterLoadDFMValues;
    frmFinanceiro.lblQuantidadeCompras.AfterLoadDFMValues;
    ClientesDataset.AfterLoadDFMValues;
    ClientesDatasetid.AfterLoadDFMValues;
    ClientesDatasetcodigo_interno.AfterLoadDFMValues;
    ClientesDatasetrazao_social_nome.AfterLoadDFMValues;
    ClientesDatasetnome_fantasia_apelido.AfterLoadDFMValues;
    ClientesDatasetcpf_cnpj.AfterLoadDFMValues;
    ClientesDatasetstatus.AfterLoadDFMValues;
    ClientesDatasettelefones.AfterLoadDFMValues;
    ClientesDatasetemail.AfterLoadDFMValues;
    ClientesDatasetcidadeNome.AfterLoadDFMValues;
    ClientesDatasetcidadeufSigla.AfterLoadDFMValues;
    ClientesDatasetcep.AfterLoadDFMValues;
    ClientesDatasetendereco.AfterLoadDFMValues;
    ClientesDatasetnumero.AfterLoadDFMValues;
    ClientesDatasetbairro.AfterLoadDFMValues;
    ClientesDatasetcomplemento.AfterLoadDFMValues;
    ClientesDatasetcadastro.AfterLoadDFMValues;
    ClientesDatasetis_pj.AfterLoadDFMValues;
    ClientesDatasetexcluido.AfterLoadDFMValues;
    ClientesDatasetinclusao.AfterLoadDFMValues;
    ClientesDatasetalteracao.AfterLoadDFMValues;
    ClientesDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
  end;
end;

end.
